import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';
import FetchService from '../../../core/services/FetchService';
import DraftItemListService from './DraftItemListService';
import { action, extendObservable } from 'mobx';

class DraftItemListBatchActionsService {
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      selectedItems: [],
    });
  }

  init = action(() => {
    this.selectedItems = [];
  });

  isSomeItemAssetsStatusPending = (items) => {
    return items.some(
      (item) =>
        (item.audioAssetsStatus && item.audioAssetsStatus !== 'DONE') ||
        (item.imageAssetsStatus && item.imageAssetsStatus !== 'DONE') ||
        (item.videoAssetsStatus && item.videoAssetsStatus !== 'DONE')
    );
  };

  handlePublishSelectedDrafts = () => {
    if (
      this.isSomeItemAssetsStatusPending(
        DraftItemListService.selectedItems.map((selectedItemId) =>
          DraftItemListService.items.find((item) => item.id === selectedItemId)
        )
      )
    ) {
      NotificationService.addNotification(
        'To publish selected drafts, all of them need to have all assets status as Done.',
        'error'
      );
      return;
    }
    ConfirmationDialogService.show(
      'Publish',
      'Would you like to publish all select drafts? All selected drafts will be changed to "Published" status and everyone will be shown to students.',
      () => {
        this.submit
          .fetch({
            url: '/draft-items/publish/batch',
            method: 'patch',
            body: {
              drafts: DraftItemListService.selectedItems,
            },
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification('All selected drafts published successfully.', 'success');
              DraftItemListService.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification('Error publishing all selected drafts.', 'error');
            }
          });
      }
    );
  };

  handlePublishEntireUnit = () => {
    if (this.isSomeItemAssetsStatusPending(DraftItemListService.items)) {
      NotificationService.addNotification(
        'To publish unit, all its drafts need to have all assets status as Done.',
        'error'
      );
      return;
    }
    const unit = DraftItemListService.form.getValue('unit');
    const item = DraftItemListService.items.find((item) => item.unit.id === unit);
    ConfirmationDialogService.show(
      'Publish',
      `Would you like to publish unit "${item.unit.name}"? This unit and also all of its drafts will be changed to "Published" status and will be shown to students.`,
      () => {
        this.submit
          .fetch({
            url: `/units/${unit}/publish`,
            method: 'patch',
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification('Unit and all its drafts published successfully.', 'success');
              DraftItemListService.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification('Error publishing unit and all its drafts.', 'error');
            }
          });
      }
    );
  };

  handlePublishEntireMasteryTest = () => {
    if (this.isSomeItemAssetsStatusPending(DraftItemListService.items)) {
      NotificationService.addNotification(
        'To publish mastery test, all its drafts need to have all assets status as Done.',
        'error'
      );
      return;
    }
    const masteryTest = DraftItemListService.form.getValue('masteryTest');
    const item = DraftItemListService.items.find((item) => item.masteryTest?.id === masteryTest);
    ConfirmationDialogService.show(
      'Publish',
      `Would you like to publish the mastery test "${item.masteryTest.modulePercentageToActive}% "? This mastery test and also all of its drafts will be changed to "Published" status and will be shown to students.`,
      () => {
        this.submit
          .fetch({
            url: `/mastery-tests/${masteryTest}/publish`,
            method: 'patch',
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification('Mastery Test and all its drafts published successfully.', 'success');
              DraftItemListService.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification('Error publishing mastery test and all its drafts.', 'error');
            }
          });
      }
    );
  };
}

const draftItemListBatchActionsService = new DraftItemListBatchActionsService();

export default draftItemListBatchActionsService;
